import { Box, Stack, Typography } from '@mui/material';
import { getUserFullName } from '@schooly/utils/get-user-full-name';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { RichText } from '../../../components/ui/Input';
import { useMessage } from '../../../context/messages/useMessage';
import { IncomingAttachment, MessageInteractor } from '@schooly/api';
import { AttachmentFile } from '@schooly/components/form-rich-text';

import { MessagesModalPreviewSendTo } from './MessagesModalPreviewSendTo/MessagesModalPreviewSendTo';

export const MessageModalPreviewMessageInfo: FC = () => {
  const { body, attachments, actions, creator, publisher } = useMessage();

  return (
    <MessagePreviewInfoContent
      creator={creator}
      publisher={publisher}
      body={body}
      attachments={attachments}
      actions={actions}
      recipientsPreview={<MessagesModalPreviewSendTo />}
    />
  );
};

type MessagePreviewInfoContentProps = {
  creator?: MessageInteractor;
  publisher?: MessageInteractor;
  body: string;
  attachments: AttachmentFile[] | IncomingAttachment[];
  actions?: {
    fetchAttachment?: (attachmentId: string) => void;
  };
  recipientsPreview: ReactNode;
};

export const MessagePreviewInfoContent: FC<MessagePreviewInfoContentProps> = ({
  creator,
  publisher,
  body,
  attachments,
  actions,
  recipientsPreview,
}) => {
  return (
    <Box>
      <Stack direction="row" gap={5.25} pb={2}>
        {creator && (
          <Stack direction="row" gap={0.5}>
            <Typography variant="h3" color="common.grey2">
              <FormattedMessage id="messages-From" />
              {':'}
            </Typography>
            <Typography variant="h3" color="common.grey2">
              {getUserFullName(creator)}
            </Typography>
          </Stack>
        )}
        {publisher && (
          <Stack direction="row" gap={0.5}>
            <Typography variant="h3" color="common.grey2">
              <FormattedMessage id="messages-Publisher" />
            </Typography>
            <Typography variant="h3" color="common.grey2">
              {getUserFullName(publisher)}
            </Typography>
          </Stack>
        )}
      </Stack>
      {recipientsPreview}

      <RichText
        value={body}
        files={attachments}
        onAttachmentCardClick={(id) => actions?.fetchAttachment?.(id ?? '')}
        readOnly
      />
    </Box>
  );
};
